import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../components/Layout';
import Table, { TableColumn } from '../components/Table';
import { GeneralBetSummary, getGeneralBetsSummary } from '../api/tournamentStatsApi';

const GeneralBetsSummaryPage: React.FC = () => {
  const [rows, setRows] = useState<GeneralBetSummary[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchSummary = async () => {
      setLoading(true);
      setError('');
      try {
        const data = await getGeneralBetsSummary();
        setRows(data);
      } catch (err) {
        console.error('Error fetching general bets summary:', err);
        setError('Failed to load general bets summary. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  const groupedByBet = useMemo(() => {
    const groups: Record<number, GeneralBetSummary[]> = {};
    for (const row of rows) {
      if (!groups[row.bet_id]) {
        groups[row.bet_id] = [];
      }
      groups[row.bet_id].push(row);
    }
    return groups;
  }, [rows]);

  const columns: TableColumn<GeneralBetSummary>[] = [
    {
      key: 'option_label',
      title: 'אפשרות',
      render: (item) => <span className="font-medium">{item.option_label}</span>,
    },
    {
      key: 'user_count',
      title: 'מס׳ משתמשים',
      render: (item) => <span>{item.user_count}</span>,
    },
  ];

  const keyExtractor = (item: GeneralBetSummary) =>
    `${item.bet_id}-${item.option_label}`;

  const highlightCondition = (item: GeneralBetSummary) => !!item.user_bet;

  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center items-center h-64">
          <div className="text-gray-500">טוען סיכום כלליים...</div>
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="flex justify-center items-center h-64">
          <div className="text-red-500">{error}</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div>
        <h1 className="text-2xl font-bold text-white mb-6">סיכום כלליים</h1>

        <div className="flex flex-wrap gap-6 mb-8 justify-center lg:justify-start">
          {Object.entries(groupedByBet).map(([betId, items]) => {
            const betName = items[0]?.bet_name || betId;
            return (
              <div
                key={betId}
                className="w-full lg:w-auto"
              >
                <Table
              className="w-full sm:w-80"
                  title={betName}
                  data={items}
                  columns={columns}
                  keyExtractor={keyExtractor}
                  highlightCondition={highlightCondition}
                  emptyMessage="אין נתונים זמינים"
                  collapsible={true}
                  defaultCollapsed={true}
                  collapsedShowHighlightedOnly={false}
                  compact
                />
              </div>
            );
          })}
          {rows.length === 0 && (
            <div className="text-gray-400 text-center w-full">
              אין כלליים להצגה עדיין.
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default GeneralBetsSummaryPage;


